export default Object.freeze([
    { name: 'Male', value: 'Male' },
    { name: 'Female', value: 'Female' }
]);
